import { styled } from '@mui/material/styles';

export const IconStyled = styled('svg')`
  flex-shrink: 0;
`;
